module.exports = __webpack_public_path__ + "img/back_skirt_length.5c45b8d6.png";